import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Ertigaonrentinnavimumbai() {



const cardData = {
  keyword: " Ertiga On Rent in Navi Mumbai",

headingDescription:
  "Omshree Cab provides reliable and comfortable Ertiga on rent in Navi Mumbai for travelers seeking a spacious, fuel‑efficient, and practical vehicle for city travel, airport transfers, family outings, or weekend trips. The Maruti Suzuki Ertiga is a popular multi‑purpose vehicle (MPV) known for its roomy interiors, flexible seating, smooth performance, and easy driving comfort, making it ideal for families, groups, and long‑distance journeys. We offer flexible rental options including one‑way bookings, round trips, hourly packages, and full‑day rentals with transparent pricing and no hidden charges. All Ertiga vehicles in our fleet are air‑conditioned, regularly serviced, and driven by professional chauffeurs experienced with Navi Mumbai’s roads and traffic conditions. With simple online booking, punctual pickups from any location in Navi Mumbai (including airport, railway station, hotels, and residences), and 24/7 customer support, renting an Ertiga in Navi Mumbai becomes a seamless and stress‑free experience.",

topPlaces: [
  {
    title: "Central Park Kharghar",
    description:
      "Central Park in Kharghar is one of the largest urban parks in Navi Mumbai, featuring landscaped gardens, open green spaces, walking paths, and recreational areas ideal for family outings, picnics, and morning walks. Visitors enjoy the peaceful environment and scenic surroundings, making it a popular destination for relaxation. Renting an Ertiga in Navi Mumbai provides ample space and comfort for families or groups to reach this beautiful outdoor destination with ease."
  },
  {
    title: "Pandavkada Waterfalls",
    description:
      "Pandavkada Waterfalls is a scenic natural spot located near Kharghar, especially popular during the monsoon season when water flows majestically over rocky cliffs surrounded by lush greenery. Visitors often come for trekking, photography, and nature walks. A comfortable Ertiga rental from Navi Mumbai offers easy and convenient access for visitors planning a refreshing day trip to this picturesque waterfall."
  },
  {
    title: "Seawoods Grand Central Mall",
    description:
      "Seawoods Grand Central Mall is a major shopping and entertainment destination in Navi Mumbai, featuring retail outlets, restaurants, cafes, and movie theaters. Visitors enjoy shopping, dining, leisure activities, and social outings. Renting an Ertiga allows families and friends to travel comfortably to this popular mall while enjoying the spacious seating and smooth ride."
  },
  {
    title: "Utsav Chowk",
    description:
      "Utsav Chowk is a well‑known landmark in Kharghar renowned for its architectural design and decorative fountains. The surrounding area includes cafes, eateries, and shops where visitors can relax and spend leisure time. It’s a popular spot for evening visits and photography. Renting an Ertiga provides a convenient way for travelers to reach this vibrant destination with space for luggage and passengers."
  },
  {
    title: "Palm Beach Road",
    description:
      "Palm Beach Road is a scenic stretch in Navi Mumbai connecting Vashi, Nerul, and Belapur, known for its beautiful waterfront views, modern infrastructure, and smooth roads. Many people enjoy driving along this route, especially during the evening when the atmosphere is calm and pleasant. An Ertiga rental offers a comfortable ride for family drives, city sightseeing, and leisurely outings along this iconic road."
  },
  {
    title: "Belapur Fort",
    description:
      "Belapur Fort is a historical site located near CBD Belapur, offering visitors a glimpse into the region’s past with ancient fort walls and scenic surroundings. The area is perfect for history enthusiasts, photography lovers, and visitors looking to explore local heritage. Renting an Ertiga ensures a comfortable ride to this historic landmark while exploring Navi Mumbai’s attractions."
  },
  {
    title: "Golf Course Kharghar",
    description:
      "The Kharghar Golf Course is a popular recreational spot featuring wide open green spaces and well‑maintained grounds perfect for outdoor activities and leisurely walks. Visitors enjoy the peaceful environment and scenic views. Renting an Ertiga provides ample room for family or group travel to this leisure destination with comfort and convenience."
  },
  {
    title: "ISKCON Kharghar",
    description:
      "ISKCON Kharghar is a spiritual and cultural destination dedicated to Lord Krishna. The temple attracts devotees and visitors who come for prayers, meditation, and religious events. The peaceful ambience and beautiful architecture make it a serene place to visit. Renting an Ertiga allows devotees and tourists to travel comfortably to this spiritual site without worrying about seating space or luggage."
  },
  {
    title: "Nerul Balaji Temple",
    description:
      "Nerul Balaji Temple, dedicated to Lord Venkateswara, is a popular religious site in Navi Mumbai known for its majestic design and spiritual environment. Devotees and visitors come for darshan, prayers, and peaceful reflection. Renting an Ertiga provides a convenient and comfortable transport option for families or groups visiting this temple."
  },
  {
    title: "Sagar Vihar",
    description:
      "Sagar Vihar is a tranquil waterfront promenade located in Vashi overlooking the Thane Creek, ideal for evening walks, photography, and quiet moments by the water. Families, couples, and tourists enjoy the cool breeze and scenic views. Renting an Ertiga offers a comfortable ride with enough space for passengers and luggage for a relaxing visit to this waterfront destination."
  }
],



services: [
{
name: "Ertiga on Rent Navi Mumbai",
description: "Ertiga on rent in Navi Mumbai provides comfortable and affordable travel for families, corporate groups, and tourists. The Maruti Ertiga is a spacious 6–7 seater vehicle ideal for city rides, airport transfers, and long-distance journeys. Passengers enjoy smooth suspension, powerful AC, and comfortable seating during travel. Professional drivers ensure safe driving and timely pickups across Navi Mumbai locations. Pickup services are available from homes, offices, hotels, railway stations, and airports. It is an ideal option for family tours, business travel, and weekend trips. The vehicle offers excellent comfort and reliability for group transportation."
},
{
name: "Ertiga Rental Navi Mumbai",
description: "Ertiga rental in Navi Mumbai offers reliable transportation for travelers who require spacious and economical vehicles. The Ertiga provides comfortable seating and smooth driving performance for both local travel and outstation journeys. It is a popular choice for families, corporate travelers, and small groups. Professional drivers ensure punctual pickups and safe driving throughout the journey. Vehicles are well maintained with clean interiors and strong AC cooling. Customers can easily book Ertiga rental for day trips, airport transfers, and long-distance tours. The service guarantees convenient and comfortable group travel."
},
{
name: "Ertiga Cab Service Navi Mumbai",
description: "Ertiga cab service in Navi Mumbai provides dependable taxi transportation for local city rides and intercity travel. The vehicle offers spacious seating and reliable performance suitable for long journeys. Professional drivers ensure safe driving and punctual pickup services across Navi Mumbai areas. The cab is perfect for airport transfers, business travel, and family trips. Comfortable interiors and luggage space make travel more convenient. Customers enjoy relaxed and affordable group travel with this service. It is ideal for passengers looking for comfort at economical rates."
},
{
name: "Ertiga Taxi Navi Mumbai",
description: "Ertiga taxi in Navi Mumbai is a popular option for passengers looking for comfortable multi-passenger travel. The vehicle provides spacious seating and smooth ride quality suitable for both city travel and long-distance journeys. Ideal for family outings, airport pickups, and business trips. Professional drivers ensure safe driving and timely pickups across Navi Mumbai. The taxi offers air-conditioned comfort and adequate luggage space. Passengers enjoy reliable and convenient travel with experienced drivers. It is one of the most preferred MPV taxis for group transportation."
},
{
name: "Ertiga Airport Cab Navi Mumbai",
description: "Ertiga airport cab in Navi Mumbai provides comfortable airport pickup and drop services for travelers. The vehicle offers spacious seating and sufficient luggage capacity suitable for airport transfers. Professional drivers monitor travel schedules to ensure punctual pickups and drop-offs. Ideal for families, business travelers, and group airport travel. AC interiors and smooth ride performance ensure comfortable journeys. The service operates across Navi Mumbai locations for easy airport connectivity. Passengers enjoy reliable airport transportation at affordable prices."
},
{
name: "Ertiga Outstation Cab Navi Mumbai",
description: "Ertiga outstation cab in Navi Mumbai offers comfortable long-distance travel to destinations across Maharashtra and nearby states. The vehicle provides smooth highway performance and spacious seating for extended journeys. Ideal for trips to Pune, Shirdi, Nashik, Lonavala, and other tourist destinations. Professional drivers ensure safe highway driving and punctual pickup services. Comfortable interiors and luggage space make the journey relaxing. It is perfect for family vacations and pilgrimage tours. Customers enjoy reliable travel with affordable fares."
},
{
name: "Ertiga One Way Cab Navi Mumbai",
description: "Ertiga one way cab in Navi Mumbai provides economical intercity travel without the cost of return charges. This service is ideal for passengers who require only drop services to another city. The vehicle provides spacious seating and smooth highway driving performance. Professional drivers ensure safe travel and timely pickups. Ideal for airport transfers and long-distance drop journeys. Customers enjoy flexible and convenient travel options. The service offers cost-effective transportation for one-way trips."
},
{
name: "Ertiga Round Trip Taxi Navi Mumbai",
description: "Ertiga round trip taxi in Navi Mumbai offers convenient two-way transportation for passengers planning return journeys. The vehicle remains available for the entire travel schedule, making sightseeing and meetings easier. Spacious seating and powerful AC provide comfortable travel during long trips. Professional drivers ensure safe driving and reliable service throughout the journey. Ideal for weekend tours, pilgrimage trips, and business travel. Families and groups enjoy relaxed travel with flexible schedules. The service provides dependable round-trip transportation."
},
{
name: "Cheap Ertiga Rental Navi Mumbai",
description: "Cheap Ertiga rental in Navi Mumbai provides budget-friendly travel without compromising comfort or safety. Passengers can travel in spacious vehicles at economical rates suitable for families and small groups. The Ertiga offers comfortable seating, strong AC, and reliable ride quality. Professional drivers ensure safe driving and punctual pickup services. Ideal for airport transfers, city rides, and long-distance travel. Customers enjoy affordable transportation with dependable service. It is a great option for travelers seeking value for money."
},
{
name: "Ertiga Cab Booking Navi Mumbai",
description: "Ertiga cab booking in Navi Mumbai allows passengers to easily reserve spacious MPV taxis for their travel needs. Customers can book vehicles through phone or online platforms with quick confirmation. The Ertiga provides comfortable seating and smooth performance for city and highway journeys. Ideal for airport transfers, business travel, and family trips. Professional drivers ensure punctual pickups and safe driving. Booking is simple and convenient for passengers. Travelers can enjoy comfortable transportation with reliable service."
},
{
name: "Ertiga Taxi Booking Online Navi Mumbai",
description: "Ertiga taxi booking online in Navi Mumbai provides quick and convenient digital reservations for travelers. Customers can easily schedule rides online with instant booking confirmation. The vehicle offers spacious seating and comfortable interiors suitable for group travel. Ideal for airport transfers, city rides, and long-distance trips. Professional drivers ensure safe driving and punctual pickups. Online booking simplifies travel planning and saves time. Passengers enjoy hassle-free transportation with reliable service."
},
{
name: "Best Ertiga Rental Navi Mumbai",
description: "Best Ertiga rental in Navi Mumbai offers premium service with well-maintained vehicles and professional drivers. The Ertiga provides spacious seating and comfortable interiors for families and small groups. Ideal for airport travel, corporate trips, and tourist journeys. Drivers ensure punctual pickup and smooth driving across Navi Mumbai. Customers receive reliable service and comfortable travel experiences. The vehicle is suitable for both city and outstation trips. It is one of the best options for economical group transportation."
},
{
name: "Family Cab Ertiga Navi Mumbai",
description: "Family cab Ertiga in Navi Mumbai provides spacious and comfortable travel for families traveling together. The vehicle offers 6–7 passenger seating capacity with ample luggage space. Ideal for family vacations, airport travel, and weekend trips. Professional drivers ensure safe driving and comfortable journeys. Air-conditioned interiors provide relaxed travel even during long distances. The vehicle is perfect for family group transportation. Travelers enjoy safe and enjoyable rides."
},
{
name: "Corporate Ertiga Cab Navi Mumbai",
description: "Corporate Ertiga cab in Navi Mumbai provides professional transportation solutions for business travelers and corporate teams. The vehicle offers comfortable seating and reliable performance suitable for executive travel. Ideal for office travel, airport transfers, and business meetings. Professional drivers ensure punctual pickup and smooth driving. Companies can rely on efficient and dependable transportation services. Spacious interiors provide comfort for corporate staff travel. It is a practical choice for professional group transportation."
}
],

tableData: [
["Ertiga on Rent Navi Mumbai","Ertiga Rental Navi Mumbai"],
["Ertiga Cab Service Navi Mumbai","Ertiga Taxi Navi Mumbai"],
["Ertiga Airport Cab Navi Mumbai","Ertiga Outstation Cab Navi Mumbai"],
["Ertiga One Way Cab Navi Mumbai","Ertiga Round Trip Taxi Navi Mumbai"],
["Cheap Ertiga Rental Navi Mumbai","Ertiga Cab Booking Navi Mumbai"],
["Ertiga Taxi Booking Online Navi Mumbai","Best Ertiga Rental Navi Mumbai"],
["Family Cab Ertiga Navi Mumbai","Corporate Ertiga Cab Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Spacious 6+1 Seater Comfort",
    WhyChoosedescription: "Maruti Ertiga is a spacious 6+1 seater vehicle ideal for family travel, airport transfers, and corporate trips in Navi Mumbai. It offers comfortable seating, powerful air conditioning, and sufficient luggage space for a smooth journey."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Ertiga on rent in Navi Mumbai. Customers receive clear information about per-kilometer rates, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Ertiga rental service in Navi Mumbai operates 24 hours a day. Whether you need a cab for airport pickup, late-night travel, or early morning trips, our vehicles are available anytime."
  },
  {
    WhyChooseheading: "Clean & Well Maintained Vehicles",
    WhyChoosedescription: "All Ertiga vehicles are regularly serviced, cleaned, and sanitized to provide a safe and comfortable travel experience for passengers."
  },
  {
    WhyChooseheading: "Flexible Local & Outstation Packages",
    WhyChoosedescription: "We offer flexible travel packages including local Navi Mumbai travel, airport transfers, one-way trips, and outstation tours to destinations like Pune, Nashik, Lonavala, Shirdi, and Mahabaleshwar."
  },
  {
    WhyChooseheading: "Perfect for Family & Group Travel",
    WhyChoosedescription: "Ertiga comfortably seats 6 passengers with luggage, making it a perfect option for family trips, small group tours, and corporate travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "Omshree Cabs provides convenient pickup from homes, offices, hotels, railway stations, and business locations across Navi Mumbai."
  },
  {
    WhyChooseheading: "Trusted Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Ertiga rental in Navi Mumbai thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Ertiga on rent in Navi Mumbai?", answer: "Yes, Omshree Cabs provides Maruti Ertiga rental services in Navi Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of Ertiga?", answer: "Maruti Ertiga usually accommodates 6 passengers plus the driver comfortably." },
  { question: "What is the per km rate for Ertiga in Navi Mumbai?", answer: "Ertiga rental rates typically start around ₹14–₹15 per km for outstation travel depending on the provider and package." },
  { question: "Can I book Ertiga for airport pickup?", answer: "Yes, Ertiga can be booked for Mumbai Airport and Navi Mumbai Airport pickup and drop services." },
  { question: "Is Ertiga suitable for outstation trips?", answer: "Yes, Ertiga is widely used for outstation trips from Navi Mumbai to destinations like Pune, Shirdi, Nashik, Mahabaleshwar, and Goa." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all Ertiga vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you provide driver with the car?", answer: "Yes, all Ertiga rentals include a professional driver for safe and comfortable travel." },
  { question: "Can Ertiga be used for corporate travel?", answer: "Yes, Ertiga is commonly used for corporate travel, employee transportation, and small team trips." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Patil",
    feedback:
      "We booked an Ertiga from Omshree Cabs for our Navi Mumbai to Pune trip. The vehicle was spacious and the driver was very professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Desai",
    feedback:
      "Excellent Ertiga rental service in Navi Mumbai. Clean car, punctual driver, and comfortable journey.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab offers Maruti Ertiga on rent in Navi Mumbai for airport transfers, outstation trips, one-way and round-trip travel. Affordable, family-friendly, and corporate cab services.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Ertiga on Rent",
    "Airport Transfer",
    "Outstation Cab",
    "One Way Cab",
    "Round Trip Taxi",
    "Family Cab",
    "Corporate Cab",
    "Affordable Cab Rental"
  ]
};






  return (
    <div>
      
<Helmet>
  <title>Ertiga On Rent in Navi Mumbai | Omshree Cab</title>
  <meta
    name="description"
    content="Rent a Maruti Ertiga in Navi Mumbai with Omshree Cab. Available for airport transfers, one-way trips, round trips, outstation travel, family and corporate use. Affordable and reliable service."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinnavimumbai;